import { TAG_TYPES } from "./tags";

export const pathsToGetTags = {
    '/create': TAG_TYPES.TRAINING,
    '/broadcast': TAG_TYPES.BROADCAST,
    '/learners': TAG_TYPES.LEARNER,
}